module.exports = __webpack_public_path__ + "media/hentai-yamete.e7a9504c.mp3";